<template>
    <!--div style="margin-top: 15px">
        <div class="packet-container">
            <div style="text-align: left;font-weight: bold">Gói dịch vụ Yoclass</div>
            <div class="packet" v-for="item in lstPacket">
                <div style="font-weight: bold;font-size: 20px" class="primaryColor">{{item.name}}</div>
                <div style="font-weight: bold;font-size: 20px">
                    <div v-if="item.price<=0">Miễn phí</div>
                    <div v-else>
                        <label>{{item.price | currency}}</label>
                        <label style="font-weight: normal; font-size: 14px">/tháng/giáo viên</label>
                    </div>
                </div>
                <div class="yobutton" style="background-color: #00a650" v-if="item.status==1">Bạn đang dùng gói này</div>
                <div class="yobutton" style="background-color: orange" v-else>Mua ngay</div>
                <div>Số học sinh tối đa: {{item.maxStudent}}</div>
                <div>Dung lượng lưu trữ: {{item.storage}}</div>
                <div>Số lượng lớp học được tạo: {{item.maxClass}}</div>
            </div>
        </div>
    </div-->
    <div style="margin-top: 15px">
        <div class="package">
            <div class="packagetitle">
                <p>Gói dịch vụ Yoclass bạn đang sử dụng</p>
            </div>
            <v-layout>
                <v-flex md5 sm5 xs12>
                    <div class=" pack packprimary">
                        <div class="packet packet-1">
                            <div>
                                <p class="primary-1">Cơ bản</p>
                            </div>
                            <div class="packetfree">
                                <div class="free">Miễn phí</div>
                                <div class="yodetail">Số học sinh tối đa : 100 học sinh</div>
                                <div class="yodetail">Sử dụng đủ các tính năng Yoclass</div>
                                <div class="yodetail">Thời gian miễn phí của bạn còn lại: <span>29 ngày</span></div>
                                <div class="use">Bạn đang dùng gói này</div>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex md7 sm7 xs12>
                    <div class="pack packprofession">
                        <div class="packet packet-2">
                            <div style="text-align: left">
                                <p class="primary-1">Chuyên nghiệp</p>
                            </div>
                            <p class="price">chỉ từ<span> 19,000đ</span>/tháng/học sinh</p>
                            <v-layout wrap>
                                <v-flex xl3 lg3 md3 sm3 xs3>
                                    <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" id="col1">
                                        <img src="/p6/Yoclass_files/qlds.png"/><span>
                                        <p>Quản lý danh sách<br>học viên</p></span>
                                    </a>
                                </v-flex>
                                <v-flex xl3 lg3 md3 sm3 xs3>
                                    <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" id="col2"><img
                                            src="/p6/Yoclass_files/taolop.png"><span><p>Tạo lớp học</p></span></a>
                                </v-flex>
                                <v-flex xl3 lg 3 md3 sm3 xs3>
                                    <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" id="col3"><img
                                            src="/p6/Yoclass_files/taode.png"><span><p>Tạo đề bài tập,<br>bài kiểm tra</p></span></a>
                                </v-flex>
                                <v-flex xl3 lg3 md3 sm3 xs3>
                                    <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" id="col4"><img
                                            src="/p6/Yoclass_files/giaobai.png"><span><p>Giao bài tự luận<br>&amp; trắc nghiệm</p></span></a>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap>
                                <v-flex xl4 lg4 md4 sm4 xs4>
                                    <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" id="col5"><img
                                            src="/p6/Yoclass_files/chamb.png"><span><p>Chấm bài online<br> &amp; offline</p></span></a>
                                </v-flex>
                                <v-flex xl4 lg4 md4 sm4 xs4>
                                    <a href="http://113.190.240.47:8600/yoclass/3" id="col6"><img
                                            src="/p6/Yoclass_files/guibc.png"><span><p>Gửi báo cáo</p></span></a>
                                </v-flex>
                                <v-flex xl4 lg4 md4 sm4 xs4>
                                    <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" id="col7"><img
                                            src="/p6/Yoclass_files/thaoluan.png"><span><p>Thảo luận lớp học</p></span></a>
                                </v-flex>
                            </v-layout>
                            <div>
                                <a href="http://113.190.240.47:8600/yoclass/YC_Lop_P6a1.html#" class="upgrade">Nâng cấp</a>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
    </div>

</template>

<script>
    import {message} from '../../services';
    import axios from "axios";

    export default {
        name: 'packet-component',
        components: {},
        data() {
            return {
                lstPacket: [
                    {
                        name: "Cơ bản",
                        price: 0,
                        status: 1,
                        maxStudent: 50,
                        maxClass: "Không giới hạn",
                        storage: 500,
                    },
                    {
                        name: "Chuyên nghiệp",
                        price: 390000,
                        status: 0,
                        maxStudent: 200,
                        maxClass: "Không giới hạn",
                        storage: 1024,
                    },
                    {
                        name: "Kinh doanh",
                        price: 690000,
                        status: 0,
                        maxStudent: 50,
                        maxClass: "Không giới hạn",
                        storage: 2048,
                    },
                ],
            }
        },
        created() {
            this.searchPackage();

        },
        beforeDestroy() {
        },
        methods: {
            getPriceName: function (price) {
                if (price <= 0) {
                    return "Miễn phí"
                } else {
                    return price + "/tháng/giáo viên";
                }
            },

            searchPackage: function () {
                /*
                                let url = process.env.VUE_APP_API_URL + "/class/myclass?";
                                if (this.search != null && this.search != "") {
                                    url += "search=" + this.search;
                                }
                                axios.post(url).then(
                                    data => {
                                        this.lstClass = data;
                                    },
                                    error => {
                                        console.log(error);
                                    }
                                )
                */
            },

            selectPackage: function (clss) {
                this.$router.push("ViewClass/" + clss.classId);
            },

        }
    };
</script>